import { RULE_CODE } from "../../../core/constants/anomalyRuleCodes";

export const KNOWN_NON_FIXABLE_RULES = [
  RULE_CODE.MISSING_PERIOD_GAP,
];

export const isKnownNonFixableRule = (ruleCode) =>
  KNOWN_NON_FIXABLE_RULES.includes(ruleCode);

/** Show Fix when the row is fixable (always a child branch with current data). */
export const canShowFixAction = (record) =>
  record?.fixable === true;

export const isUomChangeRule = (ruleCode) =>
  ruleCode === RULE_CODE.UOM_MID_PERIOD_CHANGE;

/**
 * UOM sent on fix for value-only rules — locked to default, not user-editable.
 */
export const getLockedFixUom = (detail) => {
  if (!detail) return "";
  if (detail.defaultUom) return detail.defaultUom;
  const uoms = detail.relevantUoms;
  if (Array.isArray(uoms) && uoms.length > 0) return uoms[0];
  return "";
};

/**
 * Parse prior UOM from descriptions like "UOM changed from 'tCO2-e' to 'kgCO2e'..."
 */
export const parsePriorUomFromDescription = (description) => {
  if (!description) return null;
  const match = description.match(/from\s+'([^']+)'\s+to\s+'([^']+)'/i);
  return match ? match[1] : null;
};

/**
 * Determine initial UOM for the fix form.
 * UOM_MID_PERIOD_CHANGE_RULE: prefer prior UOM parsed from description.
 */
export const getInitialFixUom = (detail) => {
  if (!detail) return "";

  if (isUomChangeRule(detail.ruleCode)) {
    const priorUom = parsePriorUomFromDescription(detail.description);
    if (priorUom) return priorUom;
    if (detail.defaultUom) return detail.defaultUom;
    const uoms = detail.relevantUoms;
    if (Array.isArray(uoms) && uoms.length > 0) return uoms[0];
    return "";
  }

  return getLockedFixUom(detail);
};

/**
 * Initial corrected value for the fix form.
 * Most rules need a new value — leave empty so it is not confused with current.
 * UOM change fixes often keep the same numeric value; prefill current there.
 */
export const getInitialCorrectedValue = (detail) => {
  if (!detail || detail.currentValue == null) return "";

  if (detail.ruleCode === RULE_CODE.UOM_MID_PERIOD_CHANGE) {
    return String(detail.currentValue);
  }

  return "";
};

/** Tooltip text for expected value near the corrected value field. */
export const getExpectedValueTooltip = (detail, t) => {
  if (
    !detail ||
    detail.expectedValue == null ||
    detail.ruleCode === RULE_CODE.UOM_MID_PERIOD_CHANGE
  ) {
    return "";
  }

  return t("AnomalyDetection.expectedValueToolTip.label", {
    value: detail.expectedValue,
  });
};
